export const IFields = {
    make: "Marca",
    model : "Modello",
    version : "Versione",
    body_type : "Tipologia",
    engine: "Motore",
    fuel_type : "Alimentazione",
    mileage : "Km",
    duration: "Durata",
    deposit: "Anticipo",
    rental_amount: "Canone",
    gearbox: "Cambio",
    image:""
}


export const IFieldsPos = {
    make: 2,
    model : 3,
    version : 4,
    body_type : 5,
    engine: 7,
    km : 9,
    duration: 10,
    deposit: 11,
    rental_amount: 12,
    gearbox: 8,
    image: 1,
    fuel_type: 6
}